<script setup lang="ts">
import { useSelectReason } from '../../../model/additional-info/billing/info-autorenew-failed/select-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectReason from './info-autorenew-failed/SelectReason.vue'

defineOptions({
  name: 'InfoAutorenewFailed',
})

const { isRequired } = useSelectReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Reason"
      :required="isRequired"
    >
      <SelectReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
